import React from 'react';
import { motion } from 'framer-motion';
interface EventCardProps {
  date: string;
  title: string;
  artist: string;
  image: string;
  time: string;
  type?: string;
}
export function EventCard({
  date,
  title,
  artist,
  image,
  time,
  type
}: EventCardProps) {
  return <motion.div whileHover={{
    y: -5
  }} className="group relative w-full h-full min-h-[300px] bg-[#0B1014] border border-white/10 hover:border-[#DDA247] transition-colors duration-300 overflow-hidden cursor-pointer" data-id="element-202">
      {/* Date Header */}
      <div className="bg-black text-white text-center py-2 text-sm font-bold uppercase tracking-wider border-b border-white/10" data-id="element-203">
        {date}
      </div>

      {/* Image Container */}
      <div className="relative h-full" data-id="element-204">
        <img src={image} alt={title} className="w-full h-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500" data-id="element-205" />

        {/* Overlay Content */}
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent flex flex-col justify-end p-4 text-center" data-id="element-206">
          {type && <span className="text-[#DDA247] text-xs font-bold tracking-widest uppercase mb-2" data-id="element-207">
              {type}
            </span>}
          <h3 className="text-white font-bold text-lg mb-1 leading-tight" data-id="element-208">
            {title}
          </h3>
          <p className="text-white/90 font-bold text-xl mb-2" data-id="element-209">{artist}</p>
          <p className="text-gray-400 text-xs tracking-wider" data-id="element-210">{time}</p>
          <p className="text-[#DDA247] text-xs mt-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300 uppercase tracking-widest" data-id="element-211">
            Buy Tickets
          </p>
        </div>
      </div>
    </motion.div>;
}